import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { CertificatorCreateDto, CertificatorDto, CertificatorExcelDownloadDto, CertificatorUpdateDto, GetCertificatorsInputDto } from '../dtos/certificator/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class CertificatorService {
  private restService = inject(RestService);
  apiName = 'Planning';
  

  create = (input: CertificatorCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CertificatorDto>({
      method: 'POST',
      url: '/api/planning/certificators',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/planning/certificators/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/planning/certificators',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CertificatorDto>({
      method: 'GET',
      url: `/api/planning/certificators/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/planning/certificators/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetCertificatorsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<CertificatorDto>>({
      method: 'GET',
      url: '/api/planning/certificators',
      params: { name: input.name, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: CertificatorExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/planning/certificators/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CertificatorDto[]>({
      method: 'GET',
      url: '/api/planning/certificators/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: CertificatorUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CertificatorDto>({
      method: 'PUT',
      url: `/api/planning/certificators/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}